import { Action, Dispatch } from 'redux';
import { getIndex, deleteRemove, postIndex } from 'services/ApiCompareService';
import { reduxDispatchEvent } from 'components/Shared/communication';
import { ICompareItem } from 'models/ICompareItem';
import { handleServerError } from 'components/Shared/server/request';

export const COMPARE_ITEM_ADD = 'COMPARE_ITEM_ADD';
export const COMPARE_ITEM_REMOVE = 'COMPARE_ITEM_REMOVE';
export const COMPARE_CATALOG_REMOVE = 'COMPARE_CATALOG_REMOVE';
export const COMPARE_GET_LIST = 'COMPARE_GET_LIST';
export const COMPARE_LIST_TOGGLE = 'COMPARE_LIST_TOGGLE';

interface CompareCatalog {
  webCatalog: string;
}

interface CompareRequest extends CompareCatalog {
  productId: string;
  categoryName?: string;
}

export interface CompareRequestAction extends Action, CompareRequest {}
export interface CompareListAction extends Action {
  list: ICompareItem[];
}
export interface CompareCatalogAction extends Action, CompareCatalog {}

export const compareListToggle = (): Action => ({
  type: COMPARE_LIST_TOGGLE
});

export const compareListLoaded = (list: ICompareItem[]): CompareListAction => ({
  type: COMPARE_GET_LIST,
  list
});

export const compareAddItem = (add: CompareRequest): CompareRequestAction => ({
  type: COMPARE_ITEM_ADD,
  ...add
});

export const compareRemoveItem = (remove: CompareRequest): CompareRequestAction => ({
  type: COMPARE_ITEM_REMOVE,
  ...remove
});

export const compareRemoveCatalog = (remove: CompareCatalog): CompareCatalogAction => ({
  type: COMPARE_CATALOG_REMOVE,
  ...remove
});

export const getList = () => (dispatch: Dispatch) => {
  getIndex()
    .then(list => {
      void reduxDispatchEvent(compareListLoaded(list));
    })
    .catch(handleServerError(dispatch));
};

export const addItem = (add: CompareRequest) => (dispatch: Dispatch) => {
  return postIndex(add)
    .then(res => {
      void reduxDispatchEvent(compareAddItem({ ...add, categoryName: res.categoryName }));
    })
    .catch(handleServerError(dispatch));
};

export const removeItem =
  ({ productId, webCatalog }: CompareRequest) =>
  (dispatch: Dispatch) => {
    deleteRemove(productId, webCatalog)
      .then(resp => {
        if (resp.code === 0) {
          void reduxDispatchEvent(compareRemoveItem({ productId, webCatalog }));
        }
        if (resp.code === 1) {
          void reduxDispatchEvent(compareRemoveCatalog({ webCatalog }));
        }
      })
      .catch(handleServerError(dispatch));
  };
